__turbopack_context__.v({
  "asideToggle": "BGfOpG_asideToggle",
  "etaContainer": "BGfOpG_etaContainer",
  "left": "BGfOpG_left",
  "mapContainer": "BGfOpG_mapContainer",
  "mapMessage": "BGfOpG_mapMessage",
  "mapMessageContainer": "BGfOpG_mapMessageContainer",
  "mapMessageText": "BGfOpG_mapMessageText",
  "observatory": "BGfOpG_observatory",
  "observatoryWrapper": "BGfOpG_observatoryWrapper",
  "replayMessageInfo": "BGfOpG_replayMessageInfo",
  "right": "BGfOpG_right",
  "searchBar": "BGfOpG_searchBar",
});
